/* eslint-disable max-len */
import React from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const CustomValidation: React.FC<Props> = ({ color, ...props }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.5 7.5V13.5C2.5 17.271 2.5 19.157 3.672 20.328C4.844 21.499 6.729 21.5 10.5 21.5H13.5C17.271 21.5 19.157 21.5 20.328 20.328C21.499 19.156 21.5 17.271 21.5 13.5V7.5M2.5 7.5L3.87 5.315C4.731 3.939 5.162 3.251 5.84 2.875C6.518 2.5 7.33 2.5 8.953 2.5H15.103C16.762 2.5 17.592 2.5 18.279 2.889C18.968 3.279 19.394 3.99 20.248 5.413L21.5 7.5M2.5 7.5H21.5M12 7.5V2.5M10 10.5H14"
      stroke={color ?? (props.style?.color || '#000000')}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CustomValidation;
